import React, {useCallback, useEffect, lazy, Suspense} from 'react';
import {useLocation} from 'react-router-dom';
import queryString from 'query-string';
import axios from 'axios';
import {useSelector} from 'react-redux';

const WatchlistComponent = lazy(() => import('@quantgate-systems/watchlist'));

function WatchlistScreen(props) {
  //const {username, password} = props;
  let values = queryString.parse(window.location.search);

  const port = useSelector(state => state.app?.port);
  const {state} = useLocation();

  useEffect(() => {
    console.log('Watchlist screen called', values, port);
  }, []);

  /* const handleLogin = useCallback(() => {
        navigate('/');
    }, [navigate]); */

  const onItemClicked = useCallback(instrument => {
    console.log(port);
    if (port) {
      axios
        .post(`http://localhost:${port}/select?Symbol=${instrument?.symbol}`, {})
        .then(res => console.log(res.data))
        .catch(err => console.log(err));
    }
    console.log(instrument);
  }, []);

  if (!state?.username || !state?.password) {
    return null;
  }

  return (
    <div>
      <Suspense fallback={<div>Page is loading...</div>}>
        <WatchlistComponent
          brokerName="signals-only"
          credentials={{UserName: state?.username, Password: state?.password}}
          onItemClick={onItemClicked}
          miniFilter
          customCardBg={values.bg ? values.bg : ''}
          customCardFg={values.fg ? values.fg : ''}
        />
      </Suspense>
    </div>
  );

  /* return (
        <Sentiment
            credentials={{
                UserName: state?.username,
                Password: state?.password
            }}
            brokerName={'demo-mode'}
            symbol={'SNAP'}
            width={500}
        />
    ) */
}

export default WatchlistScreen;
